<template>
	<div class="member-order-list">
		<div class="common-header-wrap">
			<mt-header :title="$t('MyOrders')" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>
		<!-- <div class="common-header-wrap">
			<div class="common-header">
				<mt-button class="back" slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div class="common-search">
					<input type="text" v-model="keyword" :placeholder="$t('SearchPlaceholder')" @click="goOrderSearch()">
				</div>
			</div>
		</div> -->
		<!-- header -->

		<div class="search" @click="goOrderSearch">
			<div class="l">
				<div class="icon">
					<img src="../../../assets/image/home/Search.png" alt="">
				</div>
				<input type="text" v-model="keyword" :placeholder="$t('SearchPlaceholder')" readonly />
			</div>
			<div class="search1 button">{{ $t('Search') }}</div>
		</div>

		<div class="order-header">
			<ul ref="tagBar">
				<li class="item tag" v-for="(item, index) in orderNav" v-bind:key="item.id"
					v-bind:class="{ active: stateType == item.id }" v-on:click="setOrderNavActive(item.id, index)">
					{{ item.name }}
				</li>
			</ul>
		</div>
		<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
			<div class="order-body" v-if="order_group_list && order_group_list.length">
				<div v-for="(order_group, index) in order_group_list" v-bind:key="index">
					<div class="list" v-for="item in order_group.order_list" :key="item.order_id">
						<router-link :to="'/member/order_detail?order_id=' + item.order_id">
							<div class="tips-body">
								<span class="tips">{{ $t('OrderNo') }} : {{ item.order_sn }}</span>
								<span class="title tips statusTips">{{ item.state_desc }}</span>
							</div>
							<div class="order-image multiple" v-if="item.extend_order_goods.length > 1">
								<div class="imagebox">
									<img v-for="image in item.extend_order_goods" v-bind:src="image.goods_image_url" />
								</div>
							</div>
							<div class="order-image" v-else="item.extend_order_goods.length = 1">
								<div class="goods_info clearfix" v-for="image in item.extend_order_goods">
									<div class="img">
										<img v-bind:src="image.goods_image_url" />
									</div>
									<div class="goods_name">{{ image.goods_name }}</div>
									<div class="goods_price">
										<div class="price">${{ image.goods_price }}</div>
										<div class="num">X{{ image.goods_num }}</div>
									</div>
								</div>
							</div>
							<div class="order-image" v-if="item.zengpin_list">
								<div class="goods_info clearfix" v-for="image in item.zengpin_list">
									<div class="img">
										<img v-bind:src="image.image_url" />
									</div>
									<div class="goods_name">{{ image.goods_name }}</div>
									<div class="goods_price">
										<div class="price">${{ image.goods_price }}</div>
										<div class="num">X{{ image.goods_num }}</div>
									</div>
								</div>
							</div>
							<div class="order_amount">
								({{ $t('cart.total') }} {{ item.extend_order_goods.length }} {{ $t('items') }}) {{
									$t('cart.total') }}:
								<i class="order_amount_icon">$</i>
								<i class="i">{{ item.order_amount }}</i>
								<i class="i freight">({{ $t('ShippingFee') }}:${{ item.shipping_fee }})</i>
							</div>
						</router-link>
						<div class="order-list-opratio">
							<!-- Locked -->
							<button v-if="item.if_lock && item.extend_refund"
								v-on:click="goRefund(item.extend_refund.refund_id)">{{ $t('Refund in Progress') }}</button>
							<!-- Cancel Order -->
							<button v-if="item.if_cancel" v-on:click="cancel(item)">{{ $t('Cancel Order') }}</button>
							<!-- Refund and Cancel Order -->
							<button v-if="item.if_refund_cancel && item.is_box != 1" v-on:click="refund(item.order_id)"
								class="line_red">{{ $t('Refund') }}</button>
							<!-- Track Shipping -->
							<button v-if="item.if_deliver" v-on:click="deliver(item.order_id)">{{ $t('Track Shipping')
							}}</button>
							<!-- Confirm Receipt -->
							<button v-if="item.if_receive" v-on:click="receive(item.order_id)">{{ $t('Confirm Receipt')
							}}</button>
							<!-- Evaluate -->
							<button v-if="item.if_evaluation" v-on:click="evaluate(item.order_id)">{{ $t('Evaluate')
							}}</button>
							<!-- Delete -->
							<button v-if="item.if_delete" v-on:click="deleteOrder(item)">{{ $t('Delete') }}</button>
						</div>

						<!-- Individual Button for Multiple Store Consolidation Payment -->
						<div v-if="order_group.pay_amount && order_group.pay_amount > 0"
							class="common-btn ds-button-large mt-5 mb-5" @click="pay(order_group.pay_sn)">{{ $t('Pay') }}
						</div>
					</div>
				</div>
			</div>
			<empty-record v-else-if="order_group_list && !order_group_list.length"></empty-record>
		</div>
	</div>
</template>

<script>
import { getOrderList, cancelOrder, receiveOrder, deleteOrder } from '../../../api/memberOrder'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
	components: {
		EmptyRecord
	},
	name: 'MemberOrderList',
	data() {
		return {
			order_id: 0,
			keyword: this.$route.query.keyword ? this.$route.query.keyword : '', // 关键字
			orderNav: [
				{
					'name': this.$t('All'),
					'id': ''
				},
				{
					'name': this.$t('Unpaid'),
					'id': 'state_new'
				},
				{
					'name': this.$t('ToShip'),
					'id': 'state_pay'
				},
				{
					'name': this.$t('ToReceive'),
					'id': 'state_send'
				},
				{
					'name': this.$t('ToReview'),
					'id': 'state_noeval'
				}
			],
			stateType: this.$route.query.state ? this.$route.query.state : '',
			orderDetailVisible: false,
			wrapperHeight: 0,
			params: { 'page': 0, 'per_page': 10 },
			loading: false, // 是否加载更多
			isMore: true, // 是否有更多
			order_group_list: false

		}
	},

	mounted() {
		window.scrollTo(0, 0);
		this.wrapperHeight = document.documentElement.clientHeight - 140
	},
	computed: {
		...mapState({
			user: state => state.member.info
		})
	},
	created: function () {
		// this.getOrderList(true)
	},

	methods: {
		maybeGoBack() {
			// 获取当前路由
			const currentRoute = this.$route.fullPath;

			// 获取前一个路由
			const previousRoute = this.$router.options.history.state.previousRoute;

			// 检查当前路由是否与前一个路由相同
			if (currentRoute !== previousRoute) {
				// 如果不同，则允许返回
				this.$router.go(-1);
			} else {
				// 如果相同，则取消返回
				console.log('Navigation cancelled due to conflict.');
			}
		},
		goOrderSearch() {
			this.$router.push({ name: 'MemberOrderSearch' })
		},
		setOrderNavActive(index, ind) {
			this.stateType = index
			this.getOrderList(true)
			this.centerTag(ind);
		},
		centerTag(index) {
			const tagElements = this.$refs.tagBar.getElementsByClassName('tag');
			if (tagElements.length > 0) {
				const selectedTag = tagElements[index];
				const tagBar = this.$refs.tagBar;

				if (!selectedTag) return
				// 计算需要滚动的距离
				const scrollTo = selectedTag.offsetLeft + (selectedTag.offsetWidth / 2) - (tagBar.offsetWidth / 2);

				// 设置平滑滚动
				tagBar.scrollTo({
					left: scrollTo,
					behavior: 'smooth'
				});
			}
		},
		showMessage(message, title) {
			MessageBox.alert(message, title)
		},
		deleteOrder(orderInfo) {
			MessageBox({
				title: that.$t('MessageBox.Tips'),
				message: that.$t('MessageBox.delete.order'),
				confirmButtonText: that.$t('MessageBox.Confirm'),
				cancelButtonText: that.$t('MessageBox.Cancel'),
				showCancelButton: true
			}).then(action => {
				if (action == 'confirm') {
					deleteOrder(orderInfo.order_id).then(res => {
						this.getOrderList(true)
					}).catch(function (error) {
						Toast(error.message)
					})
				}
			})
		},
		cancel(orderInfo) {
			MessageBox({
				title: that.$t('MessageBox.Tips'),
				message: that.$t('MessageBox.cancel.order'),
				confirmButtonText: that.$t('MessageBox.Confirm'),
				cancelButtonText: that.$t('MessageBox.Cancel'),
				showCancelButton: true
			}).then(action => {
				if (action == 'confirm') {
					cancelOrder(orderInfo.order_id).then(res => {
						this.getOrderList(true)
					}).catch(function (error) {
						Toast(error.message)
					})
				}
			})
		},
		receive(orderId) {
			MessageBox({
				title: that.$t('MessageBox.Tips'),
				message: that.$t('MessageBox.receive.order'),
				confirmButtonText: that.$t('MessageBox.Confirm'),
				cancelButtonText: that.$t('MessageBox.Cancel'),
				showCancelButton: true
			}).then(action => {
				if (action == 'confirm') {
					receiveOrder(orderId).then(res => {
						this.getOrderList(true)
					}).catch(function (error) {
						Toast(error.message)
					})
				}
			})
		},
		deliver(orderId) {
			this.$router.push({ name: 'MemberOrderDeliver', query: { order_id: orderId } })
		},
		goRefund(refundId) {
			this.$router.push({ name: 'MemberRefundView', query: { refund_id: refundId } })
		},
		refund(orderId) {
			this.$router.push({ name: 'MemberRefundForm', query: { order_id: orderId } })
		},
		evaluate(orderId) {
			this.$router.push({ name: 'MemberOrderEvaluate', params: { order_id: orderId } })
		},
		pay(paySn) {
			this.$router.push({ name: 'MemberBuyPay', query: { pay_sn: paySn, pay_type: 'pay_new' } })
		},
		getOrderInfo(orderId) {
			this.orderDetailVisible = true
			this.order_id = orderId
		},
		loadMore() {
			this.loading = true
			this.params.page = ++this.params.page
			if (this.isMore) {
				this.loading = false
				this.getOrderList(false)
			}
		},
		getOrderList(ifReplace) {
			Indicator.open()
			if (ifReplace) {
				this.loading = false
				this.params.page = 1
				this.isMore = true
			}

			getOrderList(this.params, this.stateType, '', this.keyword).then(res => {
				Indicator.close()
				if (res.result.hasmore) {
					this.isMore = true
				} else {
					this.isMore = false
				}

				let tOrderGroup = res.result.order_group_list

				if (tOrderGroup) {
					if (ifReplace || !this.order_group_list) {
						this.order_group_list = tOrderGroup
					} else {
						this.order_group_list = this.order_group_list.concat(tOrderGroup)
					}
				}
			}).catch(function (error) {
				Indicator.close()
				Toast(error.message)
			})
		}
	}
}
</script>
<style  lang="scss" scoped>
.search {
	margin: .5rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #F9F9F9;
	border-radius: 50px 50px 50px 50px;
	margin: .6rem 1rem;
	padding: .4rem 1rem;

	.l {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.icon {
			width: .7rem;
			height: .7rem;
			margin-right: .3rem;

			img {
				width: 100%;
				height: 100%;
				display: block;
			}
		}
	}

	.search1 {
		// background: #fa2a31;
		border-radius: 10px;
		color: #E7010C;
		// padding: 0 10px;
		font-size: .6rem;
		height: 1.6rem;
		line-height: 1.6rem;
		margin-left: 10px;
	}

	input {
		box-sizing: border-box;
		width: 100%;
		height: 1.6rem;
		border-radius: 10px;
		background-size: 0.55rem;
		font-size: 0.6rem;
		color: #000000;
		background: #F9F9F9;
		// padding-left: 1.6rem;
		border: 0;
	}
}

.member-order-list {
	min-height: 100vh;
	background: #fff;

	.back {
		background-color: #fff;
		box-shadow: none;
	}

	.common-header {
		display: flex;
		align-items: center;
		line-height: normal;
		// padding: .1rem 0;
		box-shadow: none;
	}

	.common-search {
		padding: 0;
		padding-left: $pageSpace;
		padding-right: $pageSpace;
		flex: 1;

		input {
			box-sizing: border-box;
			width: 100%;
			height: 1.6rem;
			border-radius: 1.6rem;
			background: #F4F4F4 url(../../../assets/image/home/icon_search.png) no-repeat 0.6rem center;
			background-size: 0.55rem;
			font-size: $fontSize;
			color: #999;
			padding-left: 1.6rem;
			border: 0;
		}
	}

	.order-header {
		// position: fixed;
		height: 2rem;
		width: 100%;
		top: 2rem;
		z-index: 100;
		box-sizing: border-box;
		padding: 0 .4rem;
		overflow: hidden;
		background: rgba(255, 255, 255, 1);

		ul {
			scroll-snap-type: x mandatory;
			-webkit-overflow-scrolling: touch;
			/* iOS 平滑滚动 */
			list-style: none;
			width: auto;
			// display: flex;
			// justify-content: space-around;
			// align-content: center;
			// align-items: center;
			width: 100%;
			overflow: hidden;
			overflow-x: auto;
			white-space: nowrap;
			height: 100%;
			border-bottom: 1px solid #e8eaed;
			-ms-overflow-style: none;
			/* IE and Edge */
			scrollbar-width: none;
			/* Firefox */

			&::-webkit-scrollbar {
				display: none;
				/* Chrome, Safari, Opera*/
			}

			li {
				box-sizing: border-box;
				margin: 0 .2rem;
				padding: .5rem .6rem;
				border-radius: 10px 10px 10px 10px;
				display: inline-block;
				font-size: $subFontSize;
				color: #333;
				height: 100%;
				text-align: center;
				line-height: 1rem;
				border-bottom: 0.1rem solid transparent;

				&.active {
					// color: $primaryColor;
					// border-bottom-color: $primaryColor;
					color: #fff;
					padding: .5rem .8rem;
					background: #E7010C;
				}
			}
		}
	}

	.order-body {
		position: relative;
		padding-top: 2.3rem;

		.list {
			width: 100%;
			margin-top: 0.5rem;

			.tips-body {
				// height: 2.2rem;
				// background: rgba(255, 255, 255, 1);
				// box-shadow: 0 0.5px 0 0 rgba(232, 234, 237, 1);
				display: flex;
				justify-content: space-between;
				padding: 0 0.75rem 0 0.5rem;

				.tips {
					font-size: $subFontSize;
					color: #333;
					// line-height: 2.2rem;
				}

				.statusTips {
					color: $primaryColor;
				}

				img {
					width: 3.8rem;
					height: 3rem;
				}
			}

			.order-image {
				height: 4.55rem;
				background: rgba(250, 250, 250, 1);
				width: 100%;
				overflow: hidden;
				overflow-x: auto;
				white-space: nowrap;

				.goods_info {
					height: 4rem;
					margin-bottom: .5rem;
					display: flex;
					align-items: center;
					padding-right: $pageSpace;

					.img {
						width: 3rem;
						height: 3rem;
						margin: .85rem .3rem .5rem;

						img {
							width: 3rem;
							height: 3rem;
							border-radius: 1px;
						}
					}

					.goods_name {
						white-space: normal;
						overflow: hidden;
						height: 2rem;
						width: 10rem;
						font-size: .7rem;
						color: #333;
					}

					.goods_price {
						margin-left: auto;
						padding-right: .75rem;
						text-align: right;

						.price {
							font-size: $subFontSize;
							color: rgba(78, 84, 93, 1);
						}

						.num {
							font-size: .6rem;
							color: #999;
							padding-top: .3rem;
						}
					}
				}
			}

			.multiple {
				.imagebox {
					width: 100%;
					overflow-x: auto;
					white-space: nowrap;

					img {
						width: 3rem;
						height: 3rem;
						margin: .85rem .3rem .5rem;
						display: inline-block;
					}
				}
			}

			.order_amount {
				font-size: $subFontSize;
				color: rgba(78, 84, 93, 1);
				// line-height: 2.2rem;
				// height: 2.2rem;
				// background-color: #fff;
				padding: 0 0.75rem 0 0;
				// border-bottom: 1px solid #e8eaed;
				box-sizing: border-box;
				text-align: right;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

				.order_amount_icon {
					font-size: $subFontSize;
					color: $primaryColor;
				}

				i {
					font-size: $h2;
					color: $primaryColor;
					padding-left: 0.15rem;
					font-style: normal;

					&.freight {
						color: #333;
						font-size: $fontSize;
					}
				}
			}
		}

		.loading-wrapper {
			text-align: center;

			p {
				color: #c3c3c3;
				font-size: $fontSize;
				margin: 0.5rem auto;
			}
		}
	}

	.order-body {
		position: relative;
		padding: .4rem .5rem;

		.list {
			width: 100%;
			padding: .7rem .6rem;
			box-sizing: border-box;
			margin-bottom: 1rem;
			background: #fafafa;
			border-radius: 10px 10px 10px 10px;

			.tips-body {
				// height: 2.2rem;
				// background: rgba(255, 255, 255, 1);
				// box-shadow: 0 0.5px 0 0 rgba(232, 234, 237, 1);
				display: flex;
				justify-content: space-between;
				padding: 0 0 .6rem;
				border-bottom: 1px solid #DEDEDE;

				.tips {
					font-size: .6rem;
					color: #7d7d7d;
					// line-height: 2.2rem;
				}

				.statusTips {
					color: $primaryColor;
				}

				.copy {
					font-weight: 600;
					margin: 0 0;
					font-size: .6rem;
				}

				img {
					width: 3.8rem;
					height: 3rem;
				}
			}

			.order-image {
				// height: 4.55rem;
				// background: rgba(250, 250, 250, 1);
				width: 100%;
				overflow: hidden;
				overflow-x: auto;
				white-space: nowrap;

				.goods_info {
					height: 3rem;
					display: flex;
					align-items: center;
					// padding-left: $pageSpace;
					// padding-right: $pageSpace;

					.img {
						width: 3rem;
						height: 3rem;
						margin: .85rem .3rem .5rem;

						img {
							width: 3rem;
							height: 3rem;
							border-radius: 1px;
						}
					}

					.goods_name {
						white-space: normal;
						overflow: hidden;
						height: 2rem;
						width: 10rem;
						font-size: .7rem;
						font-weight: 600;
						color: #333;
					}

					.goods_price {
						margin-left: auto;
						padding-right: .75rem;
						text-align: right;

						.price {
							font-size: $subFontSize;
							color: rgba(78, 84, 93, 1);
						}

						.num {
							font-size: .6rem;
							color: #999;
							padding-top: .3rem;
						}
					}
				}
			}

			.multiple {
				.imagebox {
					width: 100%;
					overflow-x: auto;
					white-space: nowrap;

					img {
						width: 3rem;
						height: 3rem;
						margin: .85rem .3rem .5rem;
						display: inline-block;
					}
				}
			}

			.number-code {
				font-size: $subFontSize;
				color: rgba(78, 84, 93, 1);
				background-color: #fff;

				.nci {
					height: 2rem;
					padding: 0 .75rem;
					border-bottom: 1px solid #e8eaed;
					display: flex;
					justify-content: space-between;
					align-items: center;

					.tit {
						margin-bottom: .1rem;
						display: flex;
						justify-content: space-between;
						align-items: center;
					}

					.cc {
						padding: 0 .1rem;
					}

					.copy {
						color: $primaryColor;
						font-weight: 600;
					}
				}
			}

			.order_amount {
				font-size: $subFontSize;
				color: rgba(78, 84, 93, 1);
				// line-height: 2.2rem;
				// height: 2.2rem;
				// background-color: #fff;
				padding: 0 0.5rem;
				// border-bottom: 1px solid #e8eaed;
				box-sizing: border-box;
				text-align: right;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				color: $primaryColor;
				font-weight: 600;

				.order_amount_icon {
					font-size: $subFontSize;
					color: $primaryColor;
				}

				i {
					font-size: $h2;
					color: $primaryColor;
					padding-left: 0.15rem;
					font-style: normal;

					&.freight {
						color: #333;
						font-size: $fontSize;
					}
				}
			}
		}

		.loading-wrapper {
			text-align: center;

			p {
				color: #c3c3c3;
				font-size: $fontSize;
				margin: 0.5rem auto;
			}
		}
	}

	.mint-popup {
		width: 100%;
		height: 11.75rem;
	}
}

.order-list-opratio {
	// height: 2.2rem;
	display: flex;
	justify-content: flex-end;
	// background: rgba(255, 255, 255, 1);
	border-radius: 0.1rem;
}

.order-list-opratio button {
	padding: .2rem .6rem;
	// width: 4.5rem;
	height: 1.5rem;
	font-size: $subFontSize;
	border-radius: 0.7rem;
	margin: 0.35rem 0.75rem 0.35rem 0;
	background-color: #fff;
	border: 1px solid #ccc;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .05);
}

.order-list-opratio .line_red {
	background-color: #fff;
	color: #f2270c;
	border: 1px solid #f2270c;
	box-shadow: 0 3px 6px 0 rgba(242, 39, 12, .1);
}

.ds-button-large {
	margin: 0 !important;
}
</style>
